<template>
  <!-- Authors Table Card -->
  <a-card :bordered="false" class="header-solid h-full" :bodyStyle="{ padding: 10 }">
    <template #title>
      <a-row type="flex" align="middle">
        <a-col :span="24" :md="12">
          <h5 class="font-semibold m-0">Report Data</h5>
        </a-col>
        <a-col :span="24" :md="12" style="display: flex; align-items: center; justify-content: flex-end">
        </a-col>
      </a-row>

      <!-- Zone A -->
      <a-row type="flex" align="middle" style="margin-top: 20px">
        <a-col :span="10">
          <a-input-search style="margin-left: 0px" placeholder="input search text" v-model="formSearchReport.searchText"
            enter-button @search="onSearchReport" />
        </a-col>
        <a-col :span="14" align="right">
          <!-- <a-button type="primary" class="mr-5"> Import </a-button> -->
          <a-button type="primary" :disabled="loadBtnExport" class="mr-5 bg-success"
            @click="onShowModal('exportEngagementData')">
            <a-icon v-if="!loadBtnExport" type="file-excel" theme="outlined" /><a-spin v-else /> Exports
          </a-button>
          <a-button type="primary" @click="toCreateData"> + Add </a-button>
        </a-col>
      </a-row>

      <div class="mt-20 mb-5" style="background: #ececec; padding: 10px">
        <a-card class="ant-card-filter" style="box-shadow: none">
          <a-row>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Member status :</p>
              <!-- <a-radio-group v-model="formSearchReport.member">
                <a-radio-button value="member">Member</a-radio-button>
                <a-radio-button value="non-member">Non-Member</a-radio-button>
              </a-radio-group> -->
              <a-button-group>
                <a-button :type="formSearchReport.member === 'member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('member')">
                  Member
                </a-button>
                <a-button :type="formSearchReport.member === 'non-member' ? 'primary' : 'default'"
                  @click="handleMemberStatusChange('non-member')">
                  Non-Member
                </a-button>
              </a-button-group>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Graduation Year :</p>
              <a-select show-search placeholder="Start" style="width: 40%" option-filter-prop="children"
                v-model="formSearchReport.yearStart">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select show-search placeholder="End" style="width: 40%" option-filter-prop="children"
                v-model="formSearchReport.yearEnd">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Nationality :</p>
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formSearchReport.nationnality">
                <a-select-option v-for="(item, index) in optionNationality" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row style="margin-top: 20px">
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Donation (Fee/Sponsorship/Charity) :</p>
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formSearchReport.donation">
                <a-select-option v-for="(item, index) in ['fee', 'sponsorship', 'charity']" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Major :</p>
              <a-select show-search placeholder="select..." style="width: 80%" option-filter-prop="children"
                v-model="formSearchReport.major">
                <a-select-option v-for="(item, index) in optionMajor" :key="index" :value="item.value">
                  {{ item.text }}
                </a-select-option>
              </a-select>
            </a-col>
            <a-col :xs="24" :sm="12" :md="8" :lg="6">
              <p class="lable-title">Fiscal Year :</p>
              <a-select show-search placeholder="Start" style="width: 40%" option-filter-prop="children"
                v-model="formSearchReport.fisicalStart">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
              -
              <a-select show-search placeholder="End" style="width: 40%" option-filter-prop="children"
                v-model="formSearchReport.fisicalEnd">
                <a-select-option v-for="(item, index) in optionYear" :key="index" :value="item">
                  {{ item }}
                </a-select-option>
              </a-select>
            </a-col>
          </a-row>
          <a-row class="mt-20">
            <a-col style="text-align: center">
              <a-button class="mr-5" type="primary" @click="onSearchReport">
                <a-icon type="search" theme="outlined" /> Search Data
              </a-button>
              <a-popconfirm placement="top" ok-text="Yes" cancel-text="No" @confirm="onclearFilter">
                <template slot="title">
                  <p>Are you sure to Clear a Filter ?</p>
                </template>
                <a-button type="danger"> Clear Filter </a-button>
              </a-popconfirm>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </template>
    <!-- {{ data }} -->
    <a-row class="mt-10 mb-10">
      <a-col :span="12" style="text-align: left">
          <a-tag color="blue">
            <p class="text-center mt-5 mb-0 font-bold">
              Total
              <span class="text-danger"> {{ countObjData }}</span>
              record
            </p>
          </a-tag>
        </a-col>
        <a-col :span="12" style="text-align: right">        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>
    <a-table :columns="columns" :data-source="data" :pagination="false" :loading="loading" size="small" bordered
      :scroll="{ x: 1500 }">
      <template slot="academic_title" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            <span v-if="
              record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1].academic_title !==
              null
            ">
              {{
                `${checkBlank(
                  record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1]
                    .academic_title_detail.name_eng
                )}`
              }}
            </span>
          </div>
        </div>
      </template>
      <template slot="alumni_title" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            <span v-if="
              record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length - 1].title_name !== null
            ">
              {{
                `${checkBlank(
                  record.alumni_profile_detail.name_detail[record.alumni_profile_detail.name_detail.length -
                    1].title_name_detail
                    .name_eng
                )}`
              }}
            </span>
          </div>
        </div>
      </template>
      <template slot="alumni_name" slot-scope="text, record">
        <div v-if="Object.keys(record.alumni_profile_detail).length !== 0">
          <div v-if="record.alumni_profile_detail.name_detail.length != 0">
            {{
              `${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_first_name
              )} ${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_middle_name
              )} ${checkBlank(
                record.alumni_profile_detail.name_detail[0].eng_last_name
              )}`
            }}
          </div>
        </div>
      </template>
      <template slot="donation" slot-scope="text, record, index">
        <div>
          <span>
            Charity : {{ record.amount_charity }}
          </span><br />
          <span>
            Fee : {{ record.amount_fee }}
          </span><br />
          <span>
            Sponsorship : {{ record.amount_sponsorship }}
          </span>
          <!-- <span v-if="record.status_import === 'error'"> -->
        </div>
      </template>
      <template slot="updated_at" slot-scope="text, record, index">
        <div>
          {{
            moment(record.updated_at).format("YYYY-MM-DD")
            + ' ' +
            moment(record.updated_at).format("LTS")
          }}
        </div>
      </template>
      <template slot="Action" slot-scope="text, record, index">
        <a-button class="mr-5" type="" icon="edit" size="small" @click="onShowModal('engagementEdit', record, index)" />
        <a-popconfirm title="Are you sure to Delete？" @confirm="removeData(record.id)">
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <a-button type="danger" icon="delete" size="small"></a-button>
        </a-popconfirm>
      </template>
    </a-table>
    <a-row class="mt-10 mb-10">
      <a-col style="text-align: right">
        <a-pagination :current="currentPage" :total="countObjData" @change="onChangePage" :defaultPageSize="perPage" />
      </a-col>
    </a-row>

    <!-- Modal component -->
    <span v-if="isShowModal">
      <component :is="currentModalComponent" :viewModal="isShowModal" :onShowModal="onShowModal"
        :onCloseModal="onCloseModal" :dataEngagement="dataEngagement" @updateTableData="updateTableData"
        :lengthDataTable="countObjData" :dataFilter="formSearchReport"></component>
    </span>
  </a-card>
  <!-- / Authors Table Card -->
</template>

<script>
import engagementEdit from "./modal/EngagementEdit.vue";
import exportEngagementData from "./modal/ExportEngagementData.vue";

const formSearchReport = {
  searchText: "",
  member: "",
  yearStart: "",
  yearEnd: "",
  nationnality: "",
  program: "",
  donation: "",
  major: "",
  fisicalStart: "",
  fisicalEnd: "",
};
export default {
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Array,
      default: () => [],
    },
    columns: {
      type: Array,
      default: () => [],
    },
    currentPage: {
      type: Number,
      default: () => 0,
    },
    countObjData: {
      type: Number,
      default: () => 0,
    },
    perPage: {
      type: Number,
      default: () => 0,
    },
    // option search
    optionNationality: {
      type: Array,
      default: () => [],
    },
    optionProgram: {
      type: Array,
      default: () => [],
    },
    optionMajor: {
      type: Array,
      default: () => [],
    },
    optionYear: {
      type: Array,
      default: () => [],
    },
    loadBtnExport: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    updateTableData({ updateData, idRecordTable }) {
      this.data[idRecordTable] = updateData
    },
    async removeData(idDel) {
      try {
        const res = await this.$http.delete(
          `/student_affair/engagement-record/${idDel}/`
        );
        if (res.status === 204) {
          // const indexDel = this.data.findIndex(
          //     (itemDel) => itemDel.id === idDel
          // );
          // this.data.splice(indexDel, 1);
          // //console.log(this.data)
          // this.$getProfileMain()
          this.$emit("search", {
            dataQuery: this.formSearchReport,
          });
          //this.$emit('deleteID', { dataId: idDel })
        } else {
          throw { res };
        }
      } catch (error) {
        this.$emit("errorNotification", {
          errorMsg: error.response.status,
          urlPath: `/student_affair/engagement-record/${idDel}/`,
        });
        this.$emit("search", {
          dataQuery: this.formSearchReport,
        });
      }
    },
    checkBlank(val) {
      return !["", null, "null"].includes(val) ? val : "";
    },
    toCreateData() {
      this.$router
        .push({
          path: "/engagement/record",
        })
        .catch((err) => { });
    },
    onChangePage(current) {
      this.currentPage = current;
      this.offset = parseInt(current - 1) * parseInt(this.perPage);
      this.$emit("changepage", {
        currentPage: this.currentPage,
        offset: this.offset,
      });
    },
    onclearFilter() {
      this.formSearchReport = JSON.parse(JSON.stringify(formSearchReport)) //Object.assign({}, formSearchReport);
      this.$emit("search", {
        dataQuery: {},
      });
    },
    onSearchReport() {
      this.$emit("search", {
        dataQuery: this.formSearchReport,
      });
    },
    handleMemberStatusChange(value) {
      this.formSearchReport.member = this.formSearchReport.member === value ? '' : value;
    },
    onShowModal(modal, recData, idRecordTable) {
      this.isShowModal = true;
      this.currentModalComponent = modal
      if (modal == 'engagementEdit') {
        this.dataEngagement = null
        let activity_name = ''
        let std_id = ''
        let obj_std_name = ''
        try {
          activity_name = recData.engement_activity_detail.name_of_activity
          std_id = recData.alumni_profile_detail.student_id
          obj_std_name = recData.alumni_profile_detail.name_detail.length > 0 ?
            recData.alumni_profile_detail.name_detail[recData.alumni_profile_detail.name_detail.length - 1] : {}
        } catch (e) {
          //console.log(e)
        }
        // //console.log(obj_std_name)
        let formEngagement = {
          donation_fee: recData.amount_fee,
          donation_sponsorship: recData.amount_sponsorship,
          donation_charity: recData.amount_charity,
          role_and_duty: recData.role_and_duty_in_the_activity,
          other_role: recData.role_and_duty_in_the_activity_other,
          items: recData.item_detail,
        };
        let formDetail = {
          id: recData.id,
          id_rec_table: idRecordTable,
          activity_name: activity_name,
          std_id: std_id,
          std_name: this.filterBlankField(obj_std_name.title_name_detail.name_eng) + ' ' + this.filterBlankField(obj_std_name.eng_first_name) + ' ' + this.filterBlankField(obj_std_name.eng_middle_name) + ' ' + this.filterBlankField(obj_std_name.eng_last_name),
        }
        let concatJsonForm = Object.assign(formEngagement, formDetail)
        this.dataEngagement = Object.assign({}, concatJsonForm)
      }
    },
    filterBlankField(val) {
      return (val && val != '-') ? val : ''
    },
    onCloseModal() {
      // this.onSearchReport();
      this.isShowModal = false;
    },
  },
  data() {
    return {
      isShowModal: false,
      currentModalComponent: 'engagementEdit',
      formSearchReport: JSON.parse(JSON.stringify(formSearchReport)),//formSearchReport,//Object.assign({}, formSearchReport),
      dataEngagement: null
    };
  },
  components: {
    engagementEdit,
    exportEngagementData
  },
  watch: {},
};
</script>
<style>
.lable-title {
  margin-top: 5px;
  margin-bottom: 5px;
}

.ant-card-head-title span {
  margin-left: 0px;
}

.ant-card-filter {
  border: none;
}
</style>